export default function ChevronLeft() {
    return (
        <svg
            width='8'
            height='13'
            viewBox='0 0 8 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M7.41 11.1784L2.83 6.58838L7.41 1.99838L6 0.588379L7.15493e-08 6.58838L6 12.5884L7.41 11.1784Z'
                fill='#67FF5A'
            />
        </svg>
    );
}
